import { IAcquaintanceLackType } from 'APIPackage/CatalogsModule/interfaces/IAcquaintanceLackType';

import { IAcquaintanceLackTypeSelectOption } from '../interfaces/IAcquaintanceLackTypeSelectOption';

export const createAcquaintanceLackTypeSelectOption = (
  acquaintanceType: IAcquaintanceLackType,
): IAcquaintanceLackTypeSelectOption => ({
  ...acquaintanceType,
  label: acquaintanceType.name,
  value: acquaintanceType.code,
});
